import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, ButtonBaseActions, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import CloudUploadRoundedIcon from "@mui/icons-material/CloudUploadRounded";
export type ConfirmPublishModal = {
  contentTitle: string;
  onCancel: () => void;
  onConfirm: () => void;
  contentVersion: number;
  altText?: string;
  isPublishing?: boolean;
  children?: JSX.Element;
  relatedItemsToPublishCount?: number;
};
export const ConfirmPublishModal = ({
  contentTitle,
  onCancel,
  onConfirm,
  contentVersion,
  altText,
  isPublishing,
  children,
  relatedItemsToPublishCount
}: ConfirmPublishModal) => {
  const {
    t
  } = useTranslation();
  const actionRef = useRef<ButtonBaseActions | null>(null);
  const onEntered = () => actionRef?.current?.focusVisible();
  return <Dialog open data-cy="ConfirmPublishModal" PaperProps={{
    sx: {
      width: 480
    }
  }} TransitionProps={{
    onEntered
  }} data-sentry-element="Dialog" data-sentry-component="ConfirmPublishModal" data-sentry-source-file="ConfirmPublishModal.tsx">
      <DialogTitle component="div" sx={{
      pb: 1
    }} data-sentry-element="DialogTitle" data-sentry-source-file="ConfirmPublishModal.tsx">
        <Stack height={40} width={40} bgcolor="green.100" borderRadius="50%" justifyContent="center" alignItems="center" marginBottom={1.5} data-sentry-element="Stack" data-sentry-source-file="ConfirmPublishModal.tsx">
          <CloudUploadRoundedIcon color="success" data-sentry-element="CloudUploadRoundedIcon" data-sentry-source-file="ConfirmPublishModal.tsx" />
        </Stack>
        <Box data-sentry-element="Box" data-sentry-source-file="ConfirmPublishModal.tsx">
          {t("shell.confirmPublishTitle", {
          item: altText || t("shell.contentItem")
        })}
          {":"}
          <Typography fontWeight={400} variant="h5" display="inline" data-sentry-element="Typography" data-sentry-source-file="ConfirmPublishModal.tsx">
            {" "}
            {contentTitle}?
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent data-sentry-element="DialogContent" data-sentry-source-file="ConfirmPublishModal.tsx">
        <Typography variant="body2" color="text.secondary" data-sentry-element="Typography" data-sentry-source-file="ConfirmPublishModal.tsx">
          {t("shell.confirmPublishBody", {
          version: contentVersion,
          item: altText ? altText?.toLowerCase() : t("shell.itemLowercase")
        })}
        </Typography>
        {children}
      </DialogContent>
      <DialogActions data-sentry-element="DialogActions" data-sentry-source-file="ConfirmPublishModal.tsx">
        <Button data-cy="CancelPublishButton" variant="text" color="inherit" onClick={onCancel} disabled={isPublishing} data-sentry-element="Button" data-sentry-source-file="ConfirmPublishModal.tsx">
          {t("common.cancel")}
        </Button>
        <Button loading={isPublishing} action={actions => actionRef.current = actions} variant="contained" color="success" sx={{
        color: "common.white"
      }} onClick={onConfirm} data-cy="ConfirmPublishButton" data-sentry-element="Button" data-sentry-source-file="ConfirmPublishModal.tsx">
          {altText || !!relatedItemsToPublishCount ? t("shell.publishItems") : t("shell.publishItem")}
          {!!relatedItemsToPublishCount && ` (${relatedItemsToPublishCount + 1})`}
        </Button>
      </DialogActions>
    </Dialog>;
};